import { useState } from 'react';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { useAuthStore } from '@/store/authStore';
import { WhatsAppButton } from '@/components/common/WhatsAppButton';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const user = useAuthStore((state) => state.user);
  const isAdmin = user?.role === 'admin';

  return (
    <div className="min-h-screen flex">
      {/* Desktop Sidebar */}
      <div className="hidden lg:block w-72 flex-shrink-0 fixed top-0 right-0 h-full z-50">
        <Sidebar 
          isOpen={true} 
          onClose={() => {}} 
          isAdmin={isAdmin}
          isMobile={false}
        />
      </div>

      {/* Mobile Sidebar */}
      <div className="lg:hidden">
        <Sidebar 
          isOpen={isSidebarOpen} 
          onClose={() => setIsSidebarOpen(false)} 
          isAdmin={isAdmin}
          isMobile={true}
        />
      </div>

      {/* Main Content */}
      <div className="flex-1 lg:mr-72">
        {/* Fixed Navbar */}
        <div className="fixed top-0 left-0 right-0 lg:right-72 z-40">
          <Navbar onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />
        </div>

        {/* Main Content Area */}
        <main className="pt-16">
          <div className="p-6">
            {children}
          </div>
        </main>

        {/* Fixed WhatsApp Button */}
        <div className="fixed bottom-6 left-6 z-20">
          <WhatsAppButton />
        </div>
      </div>
    </div>
  );
}